module.exports = __webpack_public_path__ + "static/media/w_inner_logo.2208f763.svg";